/** Debounce leading: executa imediatamente na primeira chamada e ignora chamadas seguintes dentro do timeout. */
export const debounce = <T extends unknown[]>(func: (...args: T) => void, timeout: number) => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return (...args: T) => {
    if (!timer) func(...args);
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = undefined;
    }, timeout);
  };
};
